/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { connect, Provider, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { ConnectedRouter } from "connected-react-router";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";

import store from "./store";
import history from "./store/history";

import Header from "./components/header";
import Footer from "./components/footer";
import ScrollToTop from "./components/header/scrollRoute";
import Notification from "./components/notification/index";

import { checkUserAuth, getToken, fetchCurrentUser } from "./actions/auth";
import { useAuth0 } from "@auth0/auth0-react";
import { withAuth0 } from "@auth0/auth0-react";
import MainRouter from "./routes/MainRouter";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector } from "react-redux";
import { bindActionCreators } from "redux";

import "./assets/sass/main.scss";

function App({ auth0 }) {
  const {
    handleRedirectCallback,
    isAuthenticated,
    getAccessTokenSilently,
    user,
    isLoading,
    logout,
  } = useAuth0();
  const routerHistory = useHistory();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const token = localStorage.getItem("access_token");
  const isIdentityLogin = localStorage.getItem("isIdentityLogin");

  const stripePublishKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;
  const stripePromise = stripePublishKey && stripePublishKey.trim() ? loadStripe(stripePublishKey) : null;

  const [loginUser, setLoginUser] = useState();

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`https://${domain}/userinfo`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      localStorage.setItem("useData", JSON.stringify(data));
      setLoginUser(data);
    } catch (error) {
      localStorage.clear();
      logout({
        logoutParams: { returnTo: window.location.origin }, // Redirect after logout
      });
      // localStorage.removeItem("token");
      // localStorage.removeItem("isAuthenticated");
      // history.push("/signup");
      // if (!isLoading && routerHistory) {
      //   routerHistory.push("/signup");
      // }
    }
  };

  const logoutByOwn = () => {
    localStorage.clear();
    logout({
      logoutParams: { returnTo: window.location.origin },
    });
  };

  useEffect(() => {
    if (token) {
      dispatch(fetchCurrentUser());
    }
  }, []);

  // useEffect(() => {
  //   dispatch(checkUserAuth());
  // }, []);

  // useEffect(() => {
  //   // const initializeAuth = async () => {
  //   //   try {
  //   //     if (window.location.search.includes("code=") && window.location.search.includes("state=")) {
  //   //       await handleRedirectCallback();
  //   //       window.history.replaceState({}, document.title, window.location.pathname);
  //   //     }
  //   //   } catch (error) {
  //   //     console.error("Error during authentication:", error);
  //   //   }
  //   // };

  //   if (token) {
  //     // if (isIdentityLogin) {
  //     // fetchUserInfo();
  //     // } else {
  //     //   setLoginUser(user)
  //     // }
  //   } else {
  //     if (!isIdentityLogin && !token) {
  //       (async () => {
  //         try {
  //           const token = await getAccessTokenSilently();
  //           localStorage.setItem("token", token);
  //           dispatch(getToken(token));
  //           localStorage.setItem("isAuthenticated", true);
  //           !token && toast.success(`Welcome! Thanks for signing up.`);
  //         } catch (error) {
  //           console.log(error);
  //         }
  //       })()
  //     }
  //   }
  // }, [localStorage.getItem("token"), token, isIdentityLogin, user, isAuthenticated, getAccessTokenSilently, isLoading, handleRedirectCallback, routerHistory]);

  return (
    // <Provider store={store}>
    <>
      <ConnectedRouter history={history}>
        <React.Fragment>
          <Helmet>
            <title>Ample Samples</title>
            <meta property="og:type" content="website" />
            <meta property="og:title" content="Ample Samples" />
            <meta property="og:url" content="https://app.theamplesamples.com" />
            <meta
              property="og:image"
              content="https://lh3.googleusercontent.com/pw/AIL4fc_i_3dN3rxopQO9M4hi3853JzFTvwysBwTzy75UicrLPX68E-09Ya0TJnreKF31D5RyfAWCGj63afQU1yidaju7Dyqy59dehoPGGQ6z45XBlfwqKNPmWnfWTWKkqJcM5c6kTgNRAbDYEiHpHx6F0rw=w1200-h627-s-no?authuser=0"
            />
            <meta
              property="og:description"
              content="Clear your samples quickly & accurately !"
            />
          </Helmet>
          <ScrollToTop />
          {/* <Header /> */}

          {/* {(auth?.token || token) ? (
            <div className="dropdown-custom">
              <button
                className="dropbtn"
                style={{
                  backgroundImage: `url(${loginUser?.picture})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  border: "none",
                }}
              ></button>
              <div className="dropdown-content">
                <div>{loginUser?.name || null}</div>
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={() => logoutByOwn()}
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="dropdown-custom">
              <button
                className="dropbtn"
                style={{
                  backgroundImage: `url(${loginUser?.picture})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  border: "none",
                }}
              ></button>
              <div className="dropdown-content">
                <div>{loginUser?.name || null}</div>
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={() => history?.push("/login")}
                  >
                    Log in
                  </button>
                </div>
              </div>
            </div>
          )} */}
          {/* <div style={{ marginTop: "20px" }} /> */}
          <MainRouter />

          {/* {!isLoading && <Footer isLogin={isAuthenticated} />} */}
          {/* <Footer /> */}
          <Notification />
        </React.Fragment>
      </ConnectedRouter>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* </Provider > */}
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getToken,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withAuth0(App));
